/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { combineReducers } from "redux";
import { authCustomerReducer } from "./auth-customer";
import { formQuestionsReducer } from "./form-questions";
import { orgSettingsReducer } from "./orgSettings";
import { webpageReducer } from "./webpage";
import { websiteReducer } from "./website";

const reducers = combineReducers({
    authCustomer: authCustomerReducer,
    formQuestions: formQuestionsReducer,
    orgSettings: orgSettingsReducer,
    webpage: webpageReducer,
    website: websiteReducer,
});

export default reducers;
